import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { addPagination } from 'portaltransparencia-common/libs/AddFilter';
import { connect } from 'react-redux';
import * as actions from './Actions.js';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';

export function hasValidParamValue(value) {
  return (
    value !== undefined &&
    value !== null &&
    value !== '' &&
    value !== 'null' &&
    value !== 'undefined'
  );
}

export function hasEmpenhoMovimentacaoParams(empenhoDetalhe) {
  return (
    hasValidParamValue(empenhoDetalhe.get('entidade')) &&
    hasValidParamValue(empenhoDetalhe.get('exercicio')) &&
    hasValidParamValue(empenhoDetalhe.get('empenho'))
  );
}

export function buildEmpenhoMovimentacaoFiltro(empenhoDetalhe) {
  const params = new URLSearchParams();
  const id = empenhoDetalhe.get('id');

  params.set('entidade', empenhoDetalhe.get('entidade'));
  params.set('exercicio', empenhoDetalhe.get('exercicio'));
  params.set('empenho', empenhoDetalhe.get('empenho'));

  if (hasValidParamValue(id)) {
    params.set('id', id);
  }

  return params.toString();
}

export class EmpenhoDetalheMovimentacao extends Component {
  static propTypes = {
    empenhoDetalhe: PropTypes.object.isRequired,
    movimentacao: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired,
    findEmpenhoMovimentacao: PropTypes.func.isRequired
  };

  componentDidMount() {
    if (hasEmpenhoMovimentacaoParams(this.props.empenhoDetalhe)) {
      this.searchInitialPage();
    }
  }

  componentDidUpdate(prevProps) {
    const filtro = hasEmpenhoMovimentacaoParams(this.props.empenhoDetalhe)
      ? buildEmpenhoMovimentacaoFiltro(this.props.empenhoDetalhe)
      : '';
    const filtroAnterior = hasEmpenhoMovimentacaoParams(
      prevProps.empenhoDetalhe
    )
      ? buildEmpenhoMovimentacaoFiltro(prevProps.empenhoDetalhe)
      : '';

    if (filtro && filtro !== filtroAnterior) {
      this.searchInitialPage();
    }
  }

  searchInitialPage = () => {
    const { page } = this.props;
    const initialPage = page.set('number', 0);
    page.set('size', 20);

    this.searchWithPage(initialPage);
  };

  renderItens = page => {
    let key =
      page.get('tipoLancamento') +
      '_' +
      page.get('noLiquidacao') +
      '_' +
      page.get('exercicioLiquidacao') +
      '_' +
      page.get('noPagamento') +
      '_' +
      page.get('exercicioPagamento') +
      '_' +
      page.get('nroDocumento');

    return (
      <tr key={key} data={page}>
        <td>{DateUtils.formatDateTimeShort(page.get('data'))}</td>
        <td>{page.get('descricaoTipoLancamento')}</td>
        <td>{page.get('nroDocumento')}</td>
        <td className="right">
          <NumberFormatter value={page.get('valor')} />
        </td>
        <td className="right">
          <NumberFormatter value={page.get('valorALiquidar')} />
        </td>
        <td className="right">
          <NumberFormatter value={page.get('valorAPagar')} />
        </td>
      </tr>
    );
  };

  searchWithPage = page => {
    const { findEmpenhoMovimentacao, empenhoDetalhe } = this.props;
    let filtro = buildEmpenhoMovimentacaoFiltro(empenhoDetalhe);
    let pfiltro = addPagination(page, filtro);

    findEmpenhoMovimentacao(pfiltro);
  };

  render() {
    const { page } = this.props;
    return (
      <div>
        <div>
          {page && page.get('content') && (
            <table className="panel-table striped fancy">
              <TableHeader empty={!page.get('content')}>
                <tr>
                  <TableHeaderItem
                    field="data"
                    label="Data"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="descricaoTipoLancamento"
                    label="Descrição"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="nroDocumento"
                    label="Nº Documento"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="valor"
                    label="Valor"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="valorALiquidar"
                    label="Valor a Liquidar"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="valorAPagar"
                    label="Valor a Pagar"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                </tr>
              </TableHeader>
              <tbody>{page.get('content').map(this.renderItens)}</tbody>
            </table>
          )}
        </div>
        <SearchPagination page={page} searchWithPage={this.searchWithPage} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    empenhoDetalhe: state.empenhos.get('empenhoDetalhe'),
    page: state.empenhos.get('movimentacao'),
    movimentacao: state.empenhos.get('movimentacao')
  };
}

const allActions = {
  ...actions
};

export default connect(mapStateToProps, allActions)(EmpenhoDetalheMovimentacao);
